export default __webpack_public_path__ + "static/media/patient_has_order_1.61e0cf33.svg";